import { render, staticRenderFns } from "./BaseLiftAndOptionInfo.vue?vue&type=template&id=38962102&scoped=true&lang=pug"
import script from "./BaseLiftAndOptionInfo.vue?vue&type=script&lang=js"
export * from "./BaseLiftAndOptionInfo.vue?vue&type=script&lang=js"
import style0 from "./BaseLiftAndOptionInfo.vue?vue&type=style&index=0&id=38962102&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38962102",
  null
  
)

export default component.exports